import React from 'react';
import { Menu } from 'semantic-ui-react';
import { MenuItem } from './MenuItem';
import FormInput from '../FormInput/FormInput';
import isEqual from 'lodash/isEqual';

export class FilterDrawerColumn extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      search: '',
      filterOpts: props.filterOptions,
      skipUpdate: false
    };
  }

  handleClearSearch = () => {
    this.setState({ search: '' });
  };

  handleSearchChange = (e) => {
    this.setState({ search: e.target.value });
  };

  componentDidUpdate(prevProps, prevState) {
    const { filterOptions, whoChanged, name, selectedFilters } = this.props;
    const { filterOpts } = this.state;
    const areFilterOptsNew = !isEqual(filterOpts, filterOptions);
    const didWeChange = whoChanged === name;
    const isAtLeastOneSelected =
      selectedFilters && selectedFilters.find((f) => f.name === name);
    /*
     * The goal here is when a selection is made from a column, that column will NOT filter itself based on the newly
     * filtered set of option, that way we can allow the user to make multiple selections from a column.
     **/
    if (didWeChange && isAtLeastOneSelected) {
      return false;
    } else if (areFilterOptsNew) {
      this.setState({ filterOpts: filterOptions });
    }
  }

  render() {
    const { name, title, selectedFilters, changeFilter } = this.props;
    const { search, filterOpts } = this.state;

    const selected = selectedFilters.find((f) => f.name === name);
    let filteredFilterOpts = filterOpts;
    if (search) {
      filteredFilterOpts = filteredFilterOpts.filter((v) => {
        return (
          v.value && v.value.toLowerCase().indexOf(search.toLowerCase()) !== -1
        );
      });
    }
    return (
      <Menu vertical text>
        <Menu.Item className="filter-column-title">{title}</Menu.Item>
        <Menu.Item className="filter-column-search">
          <FormInput
            icon={{
              name: 'remove circle',
              link: true,
              onClick: this.handleClearSearch
            }}
            placeholder="Search..."
            value={search}
            onChange={this.handleSearchChange}
          />
        </Menu.Item>
        <Menu.Item className="filter-column">
          <Menu.Menu>
            {filteredFilterOpts.map((filter, i) => (
              <MenuItem
                filter={filter}
                selectedFilters={selected}
                changeFilter={changeFilter}
                name={name}
                title={title}
                key={i}
              />
            ))}
          </Menu.Menu>
        </Menu.Item>
      </Menu>
    );
  }
}

export default FilterDrawerColumn;
